"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _avatar = _interopRequireDefault(require("../avatar"));

var _card = _interopRequireDefault(require("../card"));

var _blogPostCardModule = _interopRequireDefault(require("./blogPostCard.module.css"));

const BlogPostCard = _ref => {
  let {
    className,
    post,
    light,
    avatarProps
  } = _ref;
  const webinarTopicId = '28890468708';
  const podcastTopicId = '29297280696';
  return /*#__PURE__*/_react.default.createElement("a", {
    className: _blogPostCardModule.default.blogPostCardLink,
    href: `/blog/${post.slug}`
  }, /*#__PURE__*/_react.default.createElement(_card.default, {
    square: true,
    className: (0, _clsx.default)(_blogPostCardModule.default.blogPostCard, className)
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: _blogPostCardModule.default.image,
    src: post.featuredImage,
    alt: post.name
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _blogPostCardModule.default.postInfo
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _blogPostCardModule.default.staticText
  }, post.topicIds.includes(webinarTopicId) ? 'Webinar' : post.topicIds.includes(podcastTopicId) ? 'Podcast' : 'Blog Post'), /*#__PURE__*/_react.default.createElement("h3", {
    className: _blogPostCardModule.default.title
  }, post.name), /*#__PURE__*/_react.default.createElement("p", {
    className: _blogPostCardModule.default.description
  }, post.metaDescription)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_blogPostCardModule.default.author, light && _blogPostCardModule.default.light)
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, (0, _extends2.default)({}, avatarProps, {
    className: _blogPostCardModule.default.avatar,
    darkText: light,
    image: post.blogAuthor && post.blogAuthor.avatar,
    fullName: post.blogAuthor && post.blogAuthor.fullName || post.authorName,
    title: post.blogAuthor && post.blogAuthor.title || null
  })))));
};

BlogPostCard.defaultProps = {
  className: '',
  post: {
    authorName: 'Default Author Name',
    blogAuthor: {
      avatar: 'https://s3-us-west-2.amazonaws.com/observian-team/assets/avatar.png',
      fullName: 'Default Name',
      title: 'Default Title'
    },
    featuredImage: '/images/blog-post-card/250X175.png',
    name: 'Iterate on your CloudFormation Development with CodePipeline',
    metaDescription: 'Differentiate and you stand out in a crowded marketplace. Present your uniqueness and emphasize your rare attributes in your sales copy and promotions for all. Differentiate and you stand out in a crowded marketplace. Present your uniqueness and emphasize your rare attributes in your sales copy and promotions for all.',
    slug: 'default-prop-type-slug',
    topicIds: []
  },
  light: false,
  avatarProps: {
    forceAspectRatio: false
  }
};
BlogPostCard.propTypes = {
  className: _propTypes.default.string,
  post: _propTypes.default.shape({
    authorName: _propTypes.default.string,
    blogAuthor: _propTypes.default.shape({
      avatar: _propTypes.default.string,
      fullName: _propTypes.default.string,
      title: _propTypes.default.string
    }),
    featuredImage: _propTypes.default.string,
    name: _propTypes.default.string,
    metaDescription: _propTypes.default.string,
    slug: _propTypes.default.string,
    topicIds: _propTypes.default.arrayOf(_propTypes.default.string)
  }),
  light: _propTypes.default.bool,
  avatarProps: _propTypes.default.shape({
    forceAspectRatio: _propTypes.default.bool
  })
};
var _default = BlogPostCard;
exports.default = _default;